module.exports = "https://static.im-cdn.com/mjc/storefront/Melody/static/media/plus.bce2393f.svg";